import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../_uLearn/layout/core";
import Vendors from "./vendors";
import AddVendor from "./add-vendor";
import EditVendor from "./edit-vendor";
import VendorProfile from "./vendor-profile";
const profileBreadCrumbs: Array<PageLink> = [
  {
    title: "Vendors",
    path: "Vendors",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const index = () => (
  <Routes>
    <Route
      element={
        <>
          <Outlet />
        </>
      }
    >
      <Route path="*" element={<Navigate to="/error/404" />} />
      <Route
        // path=""
        index
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Vendors</PageTitle>
            <Vendors />
          </>
        }
      />
      <Route
        path="/add-vendor"
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Add vendor</PageTitle>
            <AddVendor />
          </>
        }
      />
      <Route
        path="/edit-vendor"
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>edit vendor</PageTitle>
            <EditVendor />
          </>
        }
      />
      <Route
        path="/view-vendor"
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>view vendor</PageTitle>
            <VendorProfile />
          </>
        }
      />
    </Route>
  </Routes>
);
export default index;
